import {actionChannel, select, call, put, take, takeEvery} from 'redux-saga/effects'
import _ from 'lodash'
import {
  actionAddErrors,
  actionAddQueue,
  actionFailure,
  actionRemoveQueue,
  actionSuccess,
} from './actions'
import {ADD_QUEUE} from './types'
import {configProps, requestActionProps} from './'
import { IAuthUserDevice, IAuthUserToken, MAIN_REQUEST_URL, reduxProps } from "../../constants";
import {toast} from 'react-toastify'
import {actionLoginSuccess} from "../auth"
import axios from 'axios'
import {API_URL} from '../../services'
import {store} from '../ROOT'

const configDefault: configProps = {
  errorModal: true,
  errorCallback: true,
  successCallback: true,
  errorMessage: 'errorMessage',
  successMessage: 'successMessage',
}

// Run, Forrest, Run!
function* runJob(props: any): any {
  const {payload, api, callback, requestName, config: _config}: requestActionProps = props
  const config = {
    ...configDefault,
    ...(_config || {}),
  }
  try {
    // Get payload veriable
    const {data, pushData = {}} = payload || {}

    // Request
    const response = yield api(data)

    if (!_.isUndefined(response)) {
      // Response data Manupulation
      const resData = _.isEmpty(pushData)
        ? response || {}
        : {...(response || {}), extraData: pushData}

      // Push Success
      if (response) {
        try {
          yield call(runSuccess, {requestName, data: resData})
        } catch (error) {
          let idina = error

          console.log('====================================')
          console.log(
            'reduxa hatalı data geliyor requstName= ',
            requestName,
            'hata=',
            JSON.stringify(idina)
          )
          console.log('====================================')
        }
      }

      // Callback
      if (_.isFunction(callback) && config.successCallback) {
        const statusCode = resData.code
        if (statusCode === 200 || statusCode === 201) {
          callback({type: 'SUCCESS', payload: resData})
        } else {
          callback({type: 'FAILURE', payload: resData})
        }
      }
    }
  } catch (er: any) {
    yield call(errorHandler, {
      ...er,
      payload,
      requestName,
      callback,
      config,
      prevProps: props,
    })
  }
}

// error Handler
function* errorHandler(props: any) {
  //burayı kendine göre düzenlersin

  const {
    msg = '',
    status = -1,
    data = {},
    payload,
    requestName,
    callback,
    config,
    prevProps = {},
  } = props || {}
  // Error Handler
  // eslint-disable-next-line radix

  try {
    const code = parseInt(status)

    // if (_.isNumber(code) && code !== -1 && code !== 404 && msg !== "") {

    if (_.isNumber(code) && code !== -1 && msg !== '') {
      yield call(runLogger, {
        requestName,
        request_json: payload?.data,
        response_json: prevProps?.payload?.data,
        code,
      })
      code !== 404 && code !== 401 && code !== 403 && toast.error(data.message)

      switch (code) {
        case 401:
          if (!_.isEmpty(prevProps)) {
            yield call(refreshToken, {requestName, prevProps})

            if (typeof callback === 'function' && config.errorCallback) {
              callback({
                type: 'FAILURE',
                payload: {data},
              })
            }
          }
          break
        case 201:
          toast.info('Kayıt başarıyla eklendi')
          break

        default:
          if (typeof callback === 'function' && config.errorCallback) {
            callback({type: 'FAILURE', payload: {data}})
          }

          break
      }
      yield call(runFailure, {requestName, payload: {data}})
    } else {
      yield call(runFailure, {requestName, payload: {data}})
    }
  } catch (error) {
    console.log('====================================')
    console.log('errorHandler catch ', JSON.stringify(error))
    console.log('====================================')
  }
}

function* refreshToken({prevProps, requestName}: any) {
  localStorage.clear()
  //window.location.href='/auth';
  console.log("Refresh token")
  /*const authUserToken: IAuthUserToken = yield select((state: reduxProps) => state.authReducer.authentication)
   const authUserDevice: IAuthUserDevice = yield select((state: reduxProps) => state.authReducer.device)

     try {
       // if (user.refreshToken && isQueue) {
       if (authUserToken.refreshToken) {
         const {data} = yield axios.post(
           'https://production.gokidly.com/user/api/v2/main-user-login/refresh-token',
           {
             refreshToken:authUserToken.refreshToken,
             deviceUUID: authUserDevice.deviceUUID,
           },
           {
             headers: {
               'Content-Type': 'application/json',
               'Accept-Language': 'TR',
               'Kidly-Language': 'TR',
               'Kidly-App-Version': '1.1',
               'Kidly-OS': 'web',
               Authorization: `Bearer ${authUserToken.token}`,
             },
           }
         ).catch((error)=>{
           //localStorage.clear()
           //window.location.href='/auth';
         })

         if (data) {
           yield put(actionRemoveQueue(requestName))
           yield put(
             actionLoginSuccess({
               token: data.data.token,
               refreshToken: data.data.refreshToken,
             })
           )
           yield call(runJob, {...prevProps, ...{isQueue: false}})
         }
       } else {
         // Push set Queue
         yield put(actionRemoveQueue(requestName))
       }
     } catch (e: any) {
       // yield put(actionFlushUser());
     }*/
}

// Request Failure Error Logger
function* runLogger({requestName, request_json, response_json, code}: any) {
  try {
    console.log(requestName + ' - ' + request_json + ' - ' + response_json + ' - ' + code)
    /*const user: IUser = yield select((state: reduxProps) => state.authReducer.user)
          const data = {
            device_uuid: '',
            app_version: `1.0`,
            error: true,
            action_name: requestName,
            action_message: `${requestName} ERROR`,
            user_id: user.id,
            region: 'TUR',
            language_code: 'TR',
            request_date: new Date().toISOString(),
            request_json: request_json,
            response_json: JSON.stringify(response_json),
            response_status_code: code,
          }


          yield axios.post(`${MAIN_REQUEST_URL}${API_URL.loggerModule}`, data, {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': "TR",
              'Kidly-Language': "TR",
              'Kidly-App-Version': "1.1",
              'Kidly-OS': "web",
              'Access-Control-Allow-Origin' : '*',
              'Authorization': `Bearer ${user.authentication.token}`
            }
          })*/
    //  apiAxios.logger(user.device.deviceUUID, requestName, `${requestName} Error`, user.id, request_json, response_json, code);
  } catch (error) {}
}

// Add Queue
function* addQueue(props: any) {
  yield put(actionAddQueue(props))
}

// Request Success Result
function* runSuccess({requestName, data}: any) {
  // Push Success Store
  yield put(actionSuccess(requestName, data))
  // Push set Queue
  yield put(actionRemoveQueue(requestName))

  return true
}

// Request Failure Result
function* runFailure({requestName, payload = {}}: any) {
  // Push set Error
  // yield delay(100);

  yield put(
    actionAddErrors({
      ...payload,
      requestName,
    })
  )

  yield put(actionFailure(requestName, payload))
}

function* watchRequests(props: any) {
  // Props
  const {api, type, isQueue = true} = props

  // Regex
  const matches = /(.*)_(REQUEST)/.exec(type)
  if (matches) {
    const [, requestName, matchType] = matches
    // Type Check :  REQUEST is True
    if (matchType) {
      // Api Function Check
      if (!api && typeof api === 'function') {
        throw new Error('Request verileri olması veya bir fonksiyon olması lazım "api"')
      }

      yield call(isQueue ? addQueue : runJob, {...props, ...{requestName}})
    }
  }
}

function* requestRootSaga() {
  // All redux action listen
  yield takeEvery('*', watchRequests)
}

function* requestQueueWatch(): any {
  // only AAD_QUEUE action queue
  const requestQueue = yield actionChannel(ADD_QUEUE)
  while (true) {
    const data = yield take(requestQueue)
    yield call(runJob, {...data.payload, ...{isQueue: true}})
  }
}

export {requestRootSaga, requestQueueWatch}
